export default "__VITE_ASSET__eA7bHght__"